import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import router from './router/maintenance'
import store from './store/index'
import BootstrapVue from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import ProductZoomer from 'vue-product-zoomer'
import VueFilterDateFormat from 'vue-filter-date-format';
import checkView from 'vue-check-view'
import Vuelidate from 'vuelidate'

// AOS
import AOS from 'aos'
import 'aos/dist/aos.css';
import axios from 'axios'

import Snotify, { SnotifyPosition} from 'vue-snotify'
  const options = {
    toast: {
      position: SnotifyPosition.rightTop,
    }
  }
  Vue.use(Snotify, options)

// scrollanimation dans la directive
// import scrollAnimation from './directives/scrollanimation'
// Vue.directive('scrollanimation', scrollAnimation)

// axios.defaults.baseURL = "https://be-monechapeebelle.comolapapaya.com/";
axios.defaults.baseURL = "https://api.monechappeebelle.fr/";
// axios.defaults.baseURL = "https://api.ailem.io/";

axios.defaults.withCredentials = true
// axios.defaults.headers.post['X-AUTH-TOKEN']= localStorage.getItem('token');
// axios.defaults.headers.put['X-AUTH-TOKEN']= localStorage.getItem('token');
// axios.defaults.headers.delete['X-AUTH-TOKEN']= localStorage.getItem('token');
AOS.init()

Vue.use(ProductZoomer)
// checkView
// https://www.npmjs.com/package/vue-check-view
Vue.use(checkView)
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)
Vue.use(Vuelidate)


axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if(error.response)
  {
    if (error.response.status === 401 && router.history._startLocation!="/verification" && router.history._startLocation!="/login") {
      router.push('/login')
    }
    if (error.response.status > 500) {
      router.push('/erreur-500')
    }
  }
  return Promise.reject(error)
})

// VueFilterDateFormat
// https://vuejsexamples.com/simple-datetime-filter-for-vue-js/
Vue.use(VueFilterDateFormat);

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
